'use memo';

import { AgxTag, AgxTooltip } from '@urbanx/agx.ui-components2';

export const formatTaskStageLabel = (stage: string) => stage.replace(/([a-z])([A-Z])/g, '$1 $2');

interface TaskOverflowTagProps {
  id: string;
  remainingTaskCount: number;
  tooltip: string;
}

export const TaskOverflowTag = ({ id, remainingTaskCount, tooltip }: TaskOverflowTagProps) => {
  return (
    <AgxTooltip id={id} content={tooltip}>
      <AgxTag id={id} color="var(--text-primary)">
        {`+${remainingTaskCount}`}
      </AgxTag>
    </AgxTooltip>
  );
};
